import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Announcements = () => {
  const announcements = [
    { id: 1, title: "Registration Open!", date: "2025-01-26", link: "/register" },
    { id: 2, title: "Brochure", date: "2025-01-15", link: "/brochure.pdf", download: true },
    { id: 3, title: "Early bird offer in registration", date: "Till 31st July 2025" },
    { id: 4, title: "Pre-conference workshops details by 1st April, 2025", date: "17-18th November 2025" },
    { id: 5, title: "Speaker Lineup Announced!", date: "2025-01-26" },
  ];

  const [showAll, setShowAll] = useState(false);

  const latestAnnouncements = announcements.slice(0, 5);
  const olderAnnouncements = announcements.slice(5);

  const navigate = useNavigate();

  const handleAnnouncementClick = (link) => {
    if (link?.endsWith(".pdf")) {
      const a = document.createElement("a");
      a.href = link;
      a.download = link.split('/').pop(); // Suggests a default filename for saving
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else if (link) {
      navigate(link);
    }
  };

  return (
    <div className="bg-white py-12">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-extrabold text-center text-gray-900 mb-8 tracking-wide drop-shadow-md">
          <span className="bg-gradient-to-r from-indigo-600 to-blue-400 text-transparent bg-clip-text">
            Announcements
          </span>
        </h1>

        <div className="space-y-4">
          {latestAnnouncements.map((announcement) => (
            <div
              key={announcement.id}
              className="bg-white shadow-lg hover:shadow-xl transition-transform transform hover:scale-105 p-4 rounded-md border-l-4 border-blue-600 cursor-pointer"
              onClick={() => handleAnnouncementClick(announcement.link)}
            >
              <h2 className="text-lg font-bold text-gray-800 flex items-center">
                {announcement.title}
                {announcement.id === 1 && (
                  <span className="ml-2 bg-green-200 text-green-800 text-xs font-semibold px-2 py-1 rounded-full">
                    NEW
                  </span>
                )}
              </h2>
              <p className="text-sm text-gray-500">{announcement.date}</p>
            </div>
          ))}
        </div>

        {/* Older Announcements */}
        {olderAnnouncements.length > 0 && (
          <div className="mt-6">
            {!showAll && (
              <button
                className="flex items-center justify-center mx-auto bg-[#4f46e5] text-white py-2 px-6 rounded-md hover:bg-indigo-500 transition-all duration-300 shadow-md"
                onClick={() => setShowAll(true)}
              >
                Show More Announcements
              </button>
            )}
            {showAll && (
              <div className="space-y-4 animate-fadeIn">
                {olderAnnouncements.map((announcement) => (
                  <div
                    key={announcement.id}
                    className="bg-gray-100 shadow p-4 rounded-md border-l-4 border-gray-400 cursor-pointer"
                    onClick={() => handleAnnouncementClick(announcement.link)}
                  >
                    <h2 className="text-lg font-semibold text-gray-700">
                      {announcement.title}
                    </h2>
                    <p className="text-sm text-gray-500">{announcement.date}</p>
                  </div>
                ))}
                <button
                  className="block mx-auto mt-4 bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-all duration-300"
                  onClick={() => setShowAll(false)}
                >
                  Show Less
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Announcements;
